import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/_infra/rtkBaseQuery';
import { buildLocationAPIPayload } from 'store/utils/userLocation.utils';

export const fireDangerApi = createApi({
  reducerPath: 'fireDangerApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['FireDangerWeather'],
  endpoints: (builder) => ({
    getExtendedFireDanger: builder.query({
      query: (location) => ({
        url: '/v2/custom-weather/forecast/fire-danger/extended',
        params: buildLocationAPIPayload(location),
      }),
      transformResponse: (response) => {
        console.log('getExtendedFireDanger response:', response);
        return response.result;
      },
      providesTags: ['FireDangerWeather'],
    }),
    getDetailedFireDanger: builder.query({
      query: (location) => ({
        url: '/v2/custom-weather/forecast/fire-danger/detailed',
        params: buildLocationAPIPayload(location),
      }),
      transformResponse: (response) => response.result,
      providesTags: ['FireDangerWeather'],
    }),
  }),
});

export const { useGetExtendedFireDangerQuery, useGetDetailedFireDangerQuery } = fireDangerApi;
